import { Button } from '@routific/hive';
import { useTranslation } from 'react-i18next';

interface Props {
  onCancel: () => void;
}

const CancelButton: React.FC<Props> = ({ onCancel }) => {
  const { t } = useTranslation('components');

  return <Button key="cancel" type="default" onClick={onCancel} data-testid="cancel-button">
    {t('downloadCSVModal.cancel')}
  </Button>;
};

export default CancelButton;
